import React from "react";
import styles from "./FHIRPatient.module.scss";
import DateTimePicker from "react-datetime-picker";
import { capitalize } from "../../utils/textFunctions";
import RecordOverrideOptions from "../../routes/NewSearchRecords/SearchRecordTable/RecordOverrideOptions";
import {
  overrideSummaryForAddress,
  listOfAddressTypes
} from "../../routes/NewSearchRecords/SearchRecordTable/RecordOverrideUtil";
import { formattedDateWithDefault } from "../../utils/formattedDate";
import Modal from "../../components/ModalPopup";
import ButtonList from "../../components/ButtonList";
import LinkButton from "../../components/LinkButton";
import Button from "../../components/Button";
import AnchorButton from "../../components/AnchorButton";

const LinkageHistory = ({
  data,
  summary: isSummary,
  className,
  type,
  isInvisible = false,
  isAggregateInfo = false,
  isImdm = false
}) => {
  if (isSummary || !isAggregateInfo) {
    return null;
  }

  if (data.length === 0) {
    return (
      <section>
        <h3>Linkage History</h3>
        <div>
          <h4>Empty</h4>
        </div>
      </section>
    );
  }

  const actionsTranslation = {
    A: "Record Added",
    N: "New Record",
    RD: "Record Deleted",
    S: "Split",
    M: "Merge",
    AD: "Aggregate Deleted"
  };

  return (
    <section>
      <div>
        <AnchorButton
          to={{ pathname: `linkage-history/` }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button>Full Linkage History</Button>
        </AnchorButton>
      </div>
      <div>
        <span>10 most recent results:</span>
      </div>
      <div className={className + " " + styles.header}>
        <div>
          <h4>Record ID</h4>
        </div>
        <div>
          <h4>Action</h4>
        </div>
        <div>
          <h4>Event Timestamp</h4>
        </div>
        <div>
          <h4>New Aggregate ID</h4>
        </div>
        <div>
          <h4>Previous Aggregate ID</h4>
        </div>
        <div>
          <h4>Person ID</h4>
        </div>
      </div>

      {data.map((linkageHistory, index) => {
        const linkageMap = {
          "Record ID": linkageHistory.recordId ? linkageHistory.recordId : "-",
          Action: linkageHistory.action
            ? actionsTranslation[linkageHistory.action]
            : "-",
          "New Aggregate ID": linkageHistory.newAggId
            ? linkageHistory.newAggId
            : "-",
          "Previous Aggregate ID": linkageHistory.prevAggId
            ? linkageHistory.prevAggId
            : "-",
          "Person ID": linkageHistory.personId ? linkageHistory.personId : "-",
          "Correlation ID": linkageHistory.correlationId
            ? linkageHistory.correlationId
            : "-",
          "Event Timestamp": linkageHistory.eventTimestamp
            ? formattedDateWithDefault(parseInt(linkageHistory.eventTimestamp))
            : "-",
          "Source System": linkageHistory.recordId
            ? linkageHistory.recordId.split("|")[1]
            : "-",
          "Source Entity ID": linkageHistory.recordId
            ? linkageHistory.recordId.split("|")[2]
            : "-"
        };

        return (
          <div key={index} className={className}>
            <div>
              <div>{linkageMap["Record ID"]}</div>
            </div>
            <div>
              <div>{linkageMap["Action"]}</div>
            </div>
            <div>
              <div>{linkageMap["Event Timestamp"]}</div>
            </div>
            <div>
              <div>{linkageMap["New Aggregate ID"]}</div>
            </div>
            <div>
              <div>{linkageMap["Previous Aggregate ID"]}</div>
            </div>
            <div>
              <div>{linkageMap["Person ID"]}</div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default LinkageHistory;
